/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../login/login.model.ts" />
/// <reference path="../../../typings/globals/google.maps/index.d.ts" />
/// <reference path="../../../typings/globals/google.maps/geolocation-marker.d.ts" />
/// <reference path="../../../typings/globals/google.maps/marker-clusterer.d.ts" />

module Eseebase {
    export class MapController implements angular.IController {
        public coordinates: FileCoordinate[];
        public file: FileModel;
        public markers: google.maps.Marker[];
        public map: google.maps.Map;
        public markerCluster: MarkerClusterer;
        public showStatistics: boolean;
        public statistics: StatisticsViewModel;
        public statisiticsPageCount: number;
        public statisiticsPageIndex: number;
        private boundsChangedCounter: number;
        private companyNumber: string;
        private isMapLoaded: boolean;
        private ownPosition: GeolocationMarker;
        private newMarker: google.maps.Marker;
        private isCreateLocalizerMode: boolean;
        private infoWindow: google.maps.InfoWindow;
        private features: CompanyFeatureList;
        private mapSettings: MapSettings;        

        $onInit = () => { };

        constructor(private $scope: any,
            private fileService: FileService,
            private $window: ng.IWindowService,
            private cookiesService: CookiesService,
            private buildingService: BuildingService,
            private mapService: MapService,
            private $timeout: ng.ITimeoutService,
            private $rootScope: ng.IRootScopeService,
            private companyService: CompanyService,
            organizationSettingsService: OrganizationSettingsService,
            private textService: TextService) {
            var vm = this;
            var lang = this.cookiesService.readCookie('currentLanguage');
            this.showStatistics = $window.location.hash == '#!/statistics';
            this.isMapLoaded = false;
            this.boundsChangedCounter = 0;
            this.companyNumber = companyService.getCurrentCompanyNumber();
            this.loadMapSettings();
            if (this.showStatistics) {
                this.updateStatistics();
            }
            if (lang == null) {
                lang = 'en';
            }
            this.$rootScope.$on('filter-change', () => {
                if (vm.$window.location.hash != '#!/statistics' && vm.$window.location.hash != '#!/map') {
                    return;
                }
                var filters = vm.getFilters();
                if (!vm.showStatistics) {
                    fileService.getFileCoordinates(vm.companyNumber, filters).then((data: FileCoordinate[]) => {
                        vm.coordinates = data;
                        vm.addMarkersToMap(true);
                    });
                }

            });
            this.$rootScope.$on('map-view-change', () => {
                vm.loadMapSettings();
                vm.setMapViewType();
                vm.addMarkersToMap(false);
            });
            this.mapService.loadGoogleMaps(lang.substr(0, 2), 'AIzaSyD-TUHnyAt7WylVjYd7CwcLjyJXX-eNnMA').then(() =>
            {
                vm.createMap();
                vm.setMapViewType();
                var filters = vm.getFilters();
                if (!vm.showStatistics) {
                    fileService.getFileCoordinates(vm.companyNumber, filters).then((data: FileCoordinate[]) => {
                        vm.coordinates = data;
                        vm.addMarkersToMap(true);
                        //if (vm.showStatistics) {
                        //    vm.setUpdateSliderInterval();
                        //}
                    });
                }
                vm.infoWindow = new google.maps.InfoWindow({

                });
            });
            $scope.showMore = function (associationNumber: string, departmentNumber: string, localizer: string, fileName: string, isLandscape: boolean) {
                var filter = new ModelFilterViewModel();
                filter.association.values = [associationNumber];
                filter.department.values = [departmentNumber];
                filter.localizer.values = [localizer];
                filter.indoorBuildingPartType.groupBy = true;
                vm.buildingService.saveFilters(filter);
                $rootScope.$broadcast('filter-change');
                if (fileName == null || fileName == '') {
                    $window.location.href = '/#!/building/universalstorage';
                }
                else if (isLandscape) {
                    $window.location.href = '/#!/building/sim';
                }
                else{
                    $window.location.href = '/#!/building';
                }
            };
            $scope.deleteLocalizer = function () {
                if (vm.file != null && vm.file.id != null && vm.newMarker != null) {
                    vm.infoWindow.setContent($('#loadingDiv').html());
                    vm.fileService.deleteFile(vm.file.id).then(() => {
                        vm.file = null;
                        vm.newMarker.unbindAll();
                        vm.newMarker.setMap(null);
                        vm.newMarker = null;
                        vm.infoWindow.close();
                    }, () => { });
                }
            };
            $scope.saveLocalizer = function (associationId: string, departmentId: string, localizer: string) {
                var file = new FileModel();
                file.organizationalUnitId = departmentId;
                file.parentOrganizationalUnitId = associationId;
                file.localizer = localizer;
                file.projectGeoLocation = vm.file.projectGeoLocation;
                file.projectAddress = vm.file.projectAddress;
                vm.fileService.createLocalizer(file).then((id: string) => {
                    vm.file = null;
                    vm.infoWindow.close();
                    vm.newMarker.unbindAll();
                    vm.newMarker.addListener('click', function (fileId, marker, map, infoWindow) {
                        return function () { vm.createInfoWindow(fileId, false, map, marker, infoWindow) };
                    }(id, vm.newMarker, vm.map, vm.infoWindow));
                    vm.getFileDetails(id, false).then((data: string) => {
                        vm.infoWindow.setContent(data);
                        vm.infoWindow.open(vm.map, vm.newMarker);
                    });
                }, (rejection) => {
                    switch (rejection.status) {
                        case 409:
                            var infoWindowHtml = vm.infoWindow.getContent().toString();
                            var localizerExistsText = vm.textService.translate('MapPin_LocalizerAlreadExists');
                            if (infoWindowHtml.indexOf(localizerExistsText) == -1) {
                                vm.infoWindow.setContent(infoWindowHtml.replace('<p id="errorMessage" style="color:red">', '<p id="errorMessage" style="color:red">' + localizerExistsText));
                            }
                            break;
                        default:
                            break;
                    }
                });
            };
            $scope.$on('$destroy', function () {
                google.maps.event.clearInstanceListeners(window);
                google.maps.event.clearInstanceListeners(document);
                var mapElm = jQuery('#map');
                google.maps.event.clearInstanceListeners(mapElm);
                mapElm.detach();
                vm.ownPosition.setMap(null);
                vm.ownPosition = null;
            });
            $rootScope.$on('cancel-create-locality', () => {
                vm.isCreateLocalizerMode = false;
            });
            organizationSettingsService.getFeatures().then((features: CompanyFeatureList) => {
                vm.features = features;
            });
        }

        public getFilters() {
            if (this.showStatistics) {
                return new ModelFilterViewModel();
            }
            else {
                return this.buildingService.getFilters();
            }
        }

        public setUpdateStatisticsInterval() {
            var vm = this;
            this.updateStatistics();
            setInterval(() => {
                vm.updateStatistics();
            }, 10 * 60 * 1000); // every 10 minutes
        }

        public setUpdateSliderInterval() {
            var vm = this;
            this.updateSlider();
            setInterval(() => {
                vm.updateSlider();
            }, 1 * 60 * 1000); // every 1 minute
        }

        public updateSlider(direction: number = 1) {
            var vm = this;
            this.$timeout(() => {
                if ((direction == 1 && vm.statisiticsPageIndex >= vm.statisiticsPageCount) || (direction == -1 && vm.statisiticsPageIndex <= 0)) {
                    vm.statisiticsPageIndex = 1;
                }
                else {
                    vm.statisiticsPageIndex += direction;
                }
                vm.addMarkersToMap(true);
            }, 1);
        }

        public updateStatistics() {
            var vm = this;
            this.mapService
                .getStatistics()
                .then((s: StatisticsViewModel) => {
                    var filters = vm.getFilters();
                    vm.fileService.getFileCoordinates('all', filters).then((data: FileCoordinate[]) => {
                        vm.coordinates = data;
                        vm.addMarkersToMap(true);
                        vm.setUpdateSliderInterval();
                    });
                    vm.statisiticsPageIndex = 1;
                    vm.statisiticsPageCount = s.companies.length > 1 ? s.companies.length + 1: 1;
                    vm.statistics = s;
                });
        }

        public createMap() {
            var options =
                {
                    MapTypeId: google.maps.MapTypeId.TERRAIN,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    styles: this.mapService.getMapSettings()
                };
            this.map = new google.maps.Map(document.getElementById('map'), <any>options);
            var vm = this;
            
            if (!this.showStatistics) {
                var input = <HTMLInputElement>document.getElementById('mapSearchInput');
                var searchBox = new google.maps.places.SearchBox(input);
                
                if (vm.ownPosition == null) {
                    vm.ownPosition = new GeolocationMarker(vm.map);
                }
                google.maps.event.addListener(searchBox, 'places_changed', function () {
                    var places = searchBox.getPlaces();
                    var bounds = new google.maps.LatLngBounds();
                    if (places.length > 1) {
                        for (var i = 0, place; place = places[i]; i++) {
                            bounds.extend(place.geometry.location);
                        }
                        vm.map.fitBounds(bounds);
                    }
                    else if (places.length == 1) {
                        vm.map.fitBounds(places[0].geometry.viewport);
                    }

                    if (places.length > 0 && vm.isCreateLocalizerMode) {
                        vm.$rootScope.$broadcast('end-create-locality');
                        var placeLocation = places[0].geometry.location;
                        var marker = null;
                        for (var m of vm.markers) {
                            if (Coordinates.almostEqual(m.getPosition(), placeLocation)) {
                                marker = m;
                                break;
                            }
                        }
                        vm.$timeout(() => {
                            var newId = vm.markers.length;
                            if (vm.newMarker != null) {
                                newId = vm.newMarker.id;
                                vm.infoWindow.close();
                                vm.newMarker.setMap(null);
                                vm.markers = vm.markers.filter(m => m.id != newId);
                            }
                            if (marker != null) {
                                new google.maps.event.trigger(marker, 'click');
                            }
                            else {
                                vm.newMarker = new google.maps.Marker({
                                    map: vm.map,
                                    position: placeLocation,
                                    id: newId,
                                    icon: vm.getIcon(MapIconType.Unknown)
                                });
                                vm.markers.push(vm.newMarker);
                                vm.newMarker.addListener('click', function (place, marker, map, infoWindow) {
                                    return function () { vm.createNewLocalityInfoWindow(place, map, marker, infoWindow) };
                                }(places[0], vm.newMarker, vm.map, vm.infoWindow));
                                new google.maps.event.trigger(vm.newMarker, 'click');
                            }

                            
                        }, 500);
                    }
                });

                // Bias the SearchBox results towards places that are within the bounds of the
                // current map's viewport.
                google.maps.event.addListener(vm.map, 'bounds_changed', function () {
                    var bounds = vm.map.getBounds();
                    searchBox.setBounds(bounds);
                    vm.refreshMap();
                });

                google.maps.event.addListener(vm.map, 'idle', function () {
                    vm.drawBuildingOverlay();
                });
            }
            google.maps.event.addListenerOnce(this.map, 'tilesloaded', function () {
                vm.$timeout(() => vm.isMapLoaded = true);
            });
        }

        private refreshMap() {
            var vm = this;
            if (this.markerCluster == null || this.markerCluster.clusters_.length == 0) { //Cluters are not ready yet
                setTimeout(() => vm.refreshMap(), 50);
                return;
            }
            //this.boundsChangedCounter++;
            //this.$timeout(() => {
            //    vm.boundsChangedCounter--;
            //    if (vm.boundsChangedCounter == 0) {
            //        vm.drawMapOverlay();
            //    }
            //}, 50);
        }

        private drawMapOverlay() {
            var bounds = this.map.getBounds();
            var vm = this;
            for (var i = this.markers.length; i--;) {
                let marker = this.markers[i];
                if (!bounds.contains(marker.getPosition()) ||
                    this.isMarkerInCluster(marker) ||
                    (!this.mapSettings.showBuildingOverlay && !this.mapSettings.showLandscapeOverlay)) { //Hide overlay
                    if (vm.coordinates[i].overlay != null) {
                        vm.coordinates[i].overlay.setMap(null);
                        //vm.coordinates[i].overlay = null;
                    }
                }
                else {
                    if (vm.coordinates[i].overlay != null) {
                        vm.coordinates[i].overlay.setMap(vm.map);
                    }
                    //if (this.coordinates[i].geometryFaces != null) {
                    //    if (this.coordinates[i].geometryFaces.length > 0) {
                    //        var overlay = new MapGeometryOverlay(marker.getPosition(), this.coordinates[i].geometryFaces);
                    //        overlay.setMap(this.map);
                    //        this.overlays.push(overlay);
                    //    }
                    //}


                    //if (this.coordinates[i].overlay == null) {
                    //    let idx = i;
                    //    this.fileService.getApartmentsGeometry(this.coordinates[i].fileId).then((data: any) => {
                    //        var faces = <TriangulatedFace[]>data.data;
                    //        vm.coordinates[idx].geometryFaces = faces;
                    //        if (faces.length > 0) {
                    //            var overlay = new MapGeometryOverlay(marker.getPosition(), faces);
                    //            overlay.setMap(vm.map);
                    //            vm.coordinates[idx].overlay = overlay;
                    //        }
                    //    }, () => {
                    //        vm.coordinates[idx].geometryFaces = [];
                    //        vm.coordinates[idx].overlay = null;
                    //    });
                    //}
                }
            }
        }

        public drawBuildingOverlay() {
            var vm = this;
            vm.map.data.forEach(function (feature) {
                vm.map.data.remove(feature);
            });
            if (vm.map.getZoom() > 12 && (this.mapSettings.showBuildingOverlay || this.mapSettings.showLandscapeOverlay)) {
                var markerLayerUrls = [];
                for (var marker of vm.markers) {
                    var position = marker.getPosition();
                    if (vm.map.getBounds().contains(position)) {
                        if (marker.mapLayerUrl != null && marker.mapLayerUrl != '' && this.mapSettings.showLandscapeOverlay) {
                            markerLayerUrls.push(marker.mapLayerUrl);
                        }
                        else if (vm.features.displayBuildingsOnMap() && this.mapSettings.showBuildingOverlay) {
                            markerLayerUrls.push('https://dawa.aws.dk/bygninger?x=' + position.lng() + '&y=' + position.lat() + '&format=geojson')
                        }
                        if (markerLayerUrls.length > 100) {
                            break;
                        }
                    }
                }
                if (markerLayerUrls.length <= 100) {
                    for (var url of markerLayerUrls) {
                        if (url != "" && url != null) {
                            if (url.indexOf('format=geojson') > -1) {
                                vm.map.data.loadGeoJson(url);
                            }
                            else {
                                vm.map.data.loadGeoJson('/geolocation/geojson?url=' + encodeURIComponent(url));
                            }

                        }
                    }
                }
            }
        }

        public isMarkerInCluster(m: google.maps.Marker) {
            var clusters = this.markerCluster.clusters_;
            
            for (var i = 0, l = clusters.length; i < l; i++) {
                for (var j = 0, le = clusters[i].markers_.length; j < le; j++) {
                    if (m.id == clusters[i].markers_[j].id) {
                        return clusters[i].markers_.length > 1;
                    }
                }
            }
            return false;
        }


        public addMarkersToMap(zoomToMarkers: boolean) {
            if (this.map == null) {
                return;
            }
            if (this.markers != null) {
                for (var i = 0; i < this.markers.length; i++) {
                    this.markers[i].setMap(null);
                }
            }
            if (this.markerCluster != null) {
                this.markerCluster.clearMarkers();
                this.markerCluster = null;
            }
            this.markers = [];
            var vm = this;
            var bounds = new google.maps.LatLngBounds();
            var coords = this.coordinates;
            if (this.showStatistics && this.statistics != null && this.statisiticsPageIndex != this.statisiticsPageCount) {
                var companyName = this.statistics.companies[this.statisiticsPageIndex - 1].companyName.toLowerCase();
                coords = this.coordinates.filter(c => c.companyName.toLowerCase() == companyName);
            }
            for (var i = 0; i < coords.length; i++) {
                if (coords[i].coordinates == null) {
                    continue;
                }

                var iconType = MapIconType.Unknown;
                if (coords[i].mapLayerUrl == '-' || coords[i].hasDrawings == false) {
                    coords[i].mapLayerUrl = null;
                    coords[i].hasDrawings = false;
                }
                else if (coords[i].mapLayerUrl == '+' || coords[i].hasDrawings == true) {
                    coords[i].mapLayerUrl = null;
                    iconType = MapIconType.LocalizerWithModel;
                    coords[i].hasDrawings = true;
                }
                else {
                    iconType = coords[i].isLandscape ? MapIconType.Landscape : MapIconType.Building;
                }

                if ((iconType == MapIconType.Unknown && this.mapSettings.showLocalizersWithoutDrawings) ||
                    (iconType == MapIconType.LocalizerWithModel && this.mapSettings.showLocalizersWithDrawings) ||
                    (iconType == MapIconType.Building && this.mapSettings.showBuildingLocalizers) ||
                    (iconType == MapIconType.Landscape && this.mapSettings.showLandscapeLocalizers)) {

                    var marker = new google.maps.Marker({
                        map: this.map,
                        position: new Coordinates(coords[i].coordinates).toGoogle(),
                        id: i,
                        icon: this.getIcon(iconType)
                    });
                    marker.mapLayerUrl = coords[i].mapLayerUrl;
                    if (!this.showStatistics) {
                        marker.addListener('click', function (fileId, isLandscape, marker, map, infoWindow) {
                            return function () { vm.createInfoWindow(fileId, isLandscape, map, marker, infoWindow) };
                        }(coords[i].fileId, coords[i].isLandscape, marker, this.map, vm.infoWindow));
                    }
                    this.markers.push(marker);
                    bounds.extend(marker.getPosition());
                }
            }
            if (zoomToMarkers) {
                if (bounds.isEmpty()) {
                    this.map.setCenter(new google.maps.LatLng(56.1780842, 10.1119351)); // Zoom to Denmark
                    this.map.setZoom(7);
                }
                else {
                    this.map.fitBounds(bounds);
                }
            }
            if (this.showStatistics) {
                var listener = google.maps.event.addListener(vm.map, "idle", function () {
                    if (vm.map.getZoom() > 16) vm.map.setZoom(16);
                    google.maps.event.removeListener(listener);
                });
            }
            if (this.map != null && this.markers != null && this.markers.length > 0) {
                this.markerCluster = new MarkerClusterer(this.map, this.markers, { imagePath: '/assets/img/m' });
            }
            this.drawBuildingOverlay();
        }

        public startCreateLocalizer() {
            if (this.isCreateLocalizerMode) {
                this.isCreateLocalizerMode = false;
                this.$rootScope.$broadcast('end-create-locality');
            }
            else {
                this.isCreateLocalizerMode = true;
                this.$rootScope.$broadcast('start-create-locality');
            }
            
        }

        private getIcon(type: MapIconType) {
            var iconName = '';
            switch (type) {
                case MapIconType.Building:
                    iconName = 'red';
                    break;
                case MapIconType.Landscape:
                    iconName = 'green';
                    break;
                case MapIconType.Unknown:
                    iconName = 'grey';
                    break;
                case MapIconType.LocalizerWithModel:
                    iconName = 'orange';
                    break;
            }
            var image = {
                url: 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_' + iconName + '.png',
                // This marker is 20 pixels wide by 32 pixels high.
                size: new google.maps.Size(22, 40),
                // The origin for this image is (0, 0).
                origin: new google.maps.Point(0, 0),
                // The anchor for this image is the base of the flagpole at (0, 32).
                anchor: new google.maps.Point(11, 40)
            };
            return image;
        }

        private createInfoWindow(fileId: string, isLandscape: boolean, map: google.maps.Map, marker: google.maps.Marker, infoWindow: google.maps.InfoWindow) {
            var vm = this;
            vm.newMarker = marker;
            infoWindow.open(map, marker);
            infoWindow.setContent($('#loadingDiv').html());
            
            this.getFileDetails(fileId, isLandscape).then((data: string) => {
                infoWindow.setContent(data);
            });
        }

        private createNewLocalityInfoWindow(place: google.maps.places.PlaceResult, map: google.maps.Map, marker: google.maps.MVCObject, infoWindow: google.maps.InfoWindow) {
            var vm = this;
            infoWindow.open(map, marker);
            infoWindow.setContent($('#loadingDiv').html());

            if (place != null) {
                vm.file = new FileModel();
                vm.file.projectAddress = place.formatted_address;
                vm.file.projectGeoLocation = new Coordinates('' + place.geometry.location.lat() + ',' + place.geometry.location.lng());
                this.$timeout(() => infoWindow.setContent($('#mapPin').html()));
            }
        }

        private getFileDetails(fileId: string, isLandscape: boolean) {
            var vm = this;
            return this.fileService.getFile(fileId).then((file: FileModel) => {
                vm.file = file;
                if (vm.file != null) {
                    vm.file.extractOnlySimData = isLandscape;
                }
            })
                .then(() => {
                    return vm.$timeout(() => $('#mapPin').html());
                });
        }

        private setMapViewType() {
            this.map.setMapTypeId(this.mapSettings.isSattelite ? google.maps.MapTypeId.SATELLITE : google.maps.MapTypeId.ROADMAP);
        }

        private loadMapSettings() {
            this.mapSettings = <MapSettings>angular.fromJson(this.cookiesService.readCookie("mapSettings"));
            if (this.mapSettings == null) {
                this.mapSettings = new MapSettings();
            }
        }

        private saveMapSettings() {
            this.cookiesService.createCookie('mapSettings', JSON.stringify(this.mapSettings), 720);
        }

        
    }

    MapController.$inject = ['$scope', 'FileService', '$window', 'CookiesService', 'BuildingService', 'MapService', '$timeout', '$rootScope', 'CompanyService', 'OrganizationSettingsService', 'TextService'];

    angular
        .module('eseebase')
        .controller('MapController', MapController);
}